"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClearFloat = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const rpdf_renderer_1 = require("@surge-global-engineering/rpdf-renderer");
/**
 * Clears any vertical space remaining from a previously floated component
 */
const ClearFloat = () => {
    return jsx_runtime_1.jsx(rpdf_renderer_1.View, { fillPreviousWrapTextSpacing: true }, void 0);
};
exports.ClearFloat = ClearFloat;
exports.default = exports.ClearFloat;
//# sourceMappingURL=clear-float.js.map